import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as CountryJson from 'assets/json/CountryCodes.json';
import { BrandService } from '@app/api/api';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'meu-modal-create-brand',
  templateUrl: './modal-create-brand.component.html',
  styleUrls: ['./modal-create-brand.component.scss'],
})
export class ModalCreateBrandComponent implements OnInit {
  page = 1;
  filter = '';
  totalPage = 0;
  lstCountry: any = [];
  isEdit: boolean = false;
  filesLogo: File[] = [];
  isChangeLogo = false;
  hasFormErrors: boolean = false;
  logo;
  lstCountryJson: any = [];
  public controlSearch: FormControl = new FormControl();
  constructor(
    public dialogRef: MatDialogRef<ModalCreateBrandComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private brandService: BrandService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}
  filteredOptionsNation: Observable<string[]>;
  brandForm = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.pattern('^(?!\\s*$).+')]),
    code: new FormControl('', [Validators.required, Validators.pattern('^(?!\\s*$).+')]),
    nation: new FormControl(''),
  });
  ngOnInit() {
    this.lstCountryJson = Object.values(JSON.parse(JSON.stringify(CountryJson.default)));
    this.lstCountry = [...this.lstCountryJson.map((x) => x.name)];
    if (this.data.id != null) {
      this.isEdit = true;
      this.getBrandByID(this.data.id);
    }
    if (this.data.name != null) {
      this.brandForm.patchValue({
        name: this.data.name,
      });
    }
    this.filteredOptionsNation = this.brandForm.get('nation').valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.lstCountry.filter((option) => option.toLowerCase().includes(filterValue));
  }
  getBrandByID(id) {
    this.brandService.apiBrandsIdGet(id).subscribe((res) => {
      if (res.success) {
        this.brandForm.patchValue({
          name: res.data.name,
          code: res.data.code,
          nation: res.data.nation,
        });
        if (res.data.logo) {
          this.logo = environment.backendhost + res.data.logo;
        }
      }
    });
  }
  // dropzone
  onSelectLogo(event) {
    this.filesLogo = [];
    this.filesLogo.push(...event.addedFiles);

    this.isChangeLogo = true;
    this.logo = null;
  }
  onRemoveLogo(event) {
    this.filesLogo.splice(this.filesLogo.indexOf(event), 1);
  }
  //end dropzone
  save() {
    this.hasFormErrors = true;
    const controls = this.brandForm.controls;
    if (this.brandForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    if (this.filesLogo.length > 0 && !this.isEdit) {
      this.brandService.apiBrandsPost(this.brandForm.value).subscribe((res) => {
        if (res.success) {
          if (this.filesLogo.length > 0) {
            this.brandService
              .apiBrandsIdLogoPut(res.data.id, this.filesLogo[0])
              .subscribe((result1) => {
                this.dialogRef.close({ event: true, type: 'create', newItem: res.data });
              });
          }
        } else {
          this.dialogRef.close({ event: false });
        }
      });
    }
    if (this.isEdit) {
      if (
        (!this.isChangeLogo && this.logo != '') ||
        (this.filesLogo.length > 0 && this.isChangeLogo)
      ) {
        this.brandService.apiBrandsIdPut(this.data.id, this.brandForm.value).subscribe((res) => {
          if (res.success) {
            if (this.filesLogo.length > 0 && this.isChangeLogo) {
              this.brandService
                .apiBrandsIdLogoPut(res.data.id, this.filesLogo[0])
                .subscribe((result1) => {
                  this.dialogRef.close({ event: true });
                });
            }
            if (!this.isChangeLogo && this.logo != '') {
              this.dialogRef.close({ event: true });
            }
          } else {
            this.dialogRef.close({ event: false });
          }
        });
      }
    }
  }

  closeModal() {
    this.dialogRef.close();
  }
}
